"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationDropdownTrigger = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _useTrigger2 = require("../../hooks/useTrigger.js");
var _Trigger = require("./Trigger.js");
var _excluded = ["placement", "overlay", "onShow", "onHide"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function PaginationDropdownTriggerComponent(_ref) {
  var _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    overlay = _ref.overlay,
    _ref$onShow = _ref.onShow,
    onShow = _ref$onShow === void 0 ? function () {} : _ref$onShow,
    _ref$onHide = _ref.onHide,
    onHide = _ref$onHide === void 0 ? function () {} : _ref$onHide,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useTrigger = (0, _useTrigger2.useTrigger)({
      overlay: overlay,
      onShow: onShow,
      onHide: onHide
    }),
    triggerRef = _useTrigger.triggerRef,
    onClick = _useTrigger.onClick,
    onKeyDown = _useTrigger.onKeyDown;
  return /*#__PURE__*/_react["default"].createElement(_Trigger.Trigger, Object.assign({
    ref: triggerRef,
    overlay: overlay && typeof overlay === 'object' && /*#__PURE__*/(0, _react.isValidElement)(overlay) && /*#__PURE__*/(0, _react.cloneElement)(overlay),
    role: "presentation",
    placement: placement,
    onClick: onClick,
    onKeyDown: onKeyDown
  }, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.PaginationDropdownTrigger
  }));
}
var paginationDropdownTriggerHelpers = {
  /**
   * @deprecated
   * Use placement="top" instead.
   */
  top: 'top',
  /**
   * @deprecated
   * Use placement="bottom" instead.
   */
  bottom: 'bottom'
};

/**
 * PaginationDropdownTrigger is the trigger to launch the PaginationDropdownList popover.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-pagination-paginationdropdowntrigger--docs) |
 * [Encore site](https://encore.spotify.net/web/components/pagination#pagination-dropdown) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/PaginationDropdownTrigger)
 */
var PaginationDropdownTrigger = exports.PaginationDropdownTrigger = Object.assign(PaginationDropdownTriggerComponent, paginationDropdownTriggerHelpers);